export default "__VITE_ASSET__CRvn$J1B__ 400w, __VITE_ASSET__B0Zv7esF__ 800w, __VITE_ASSET__BvrPLq2o__ 1024w";